import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import { getTravelDetail } from 'actions/travelRequested';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { AirFareConditions } from 'models/flightValidation';
import { TravelDetails as TravelDetailsModel } from 'models/travelDetails';
import TravelDetails from 'screens/components/TravelDetails';
import { amplitudelogEvent, ViewTravelReservationDetailEvent } from 'services/amplitudeService';
import { amplitudeEvents } from 'utils/amplitudeEvents';

interface Props {
  show: boolean;
  id: string;
  data?: TravelDetailsModel;
  onClose: () => void;
  onConfirm?: () => void;
  onDecline?: () => void;
  onChange?: (airFareConditions?: AirFareConditions[]) => void;
  onCancel?: () => void;
}

const TravelRequestedDetails = (props: Props) => {
  const { id, onClose } = props;

  const { t } = useStoreTranslation();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const { accountResult } = useSelector((state: RootState) => state.user);

  useEffect(() => {
    if (id) {
      setData({});
      setLoading(true);
      getTravelDetail(id, accountResult?.sessionToken)
        .then(({ data: { data: details } }) => {
          setData(details);
        })
        .catch(onClose)
        .finally(() => setLoading(false));

      const amplitudeEvent: ViewTravelReservationDetailEvent = {
        SOURCE: 'MIS_VIAJES',
        ITINERARY_ID: parseInt(id),
      };

      amplitudelogEvent(amplitudeEvents.VIEW_TRAVEL_RESERVATION_DETAIL, amplitudeEvent, accountResult);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <TravelDetails
      {...props}
      loading={loading}
      title={t('userTravelResquestDetailsContainer.title')}
      data={data as TravelDetailsModel}
      requestId={id}
      userId={accountResult?.id || ''}
    />
  );
};

export default TravelRequestedDetails;
